import {
    FETCH_COMPANY_SITES,
    FETCH_SITES,
    SET_SITE,
    TOGGLE_SITE
} from '../actions/actionTypes';

const initialState = {
    companySites:   [],
    isSiteSelected: false,
    selectedSite:   {},
    sites:          []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_COMPANY_SITES:
            return {
                ...state,
                companySites: [...action.payload]
            };
        case FETCH_SITES:
            return {
                ...state,
                sites: [...action.payload]
            };
        case SET_SITE:
            return {
                ...state,
                selectedSite: {...action.payload}
            };
        case TOGGLE_SITE:
            return {
                ...state,
                isSiteSelected: action.payload
            };
        default:
            return state;
    }
};
